export default {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1920,
  ULTRA_WIDE_DESKTOP: 3440,
  WIDE_DESKTOP: 2560
};